import { fetchOrganizationGroupsSuccess } from 'actions/orgs'
import { getOrganizationGroups } from 'api/Cerebro/orgScoped/organizationApi'
import {
    cerebroApiRequest,
    cerebroApiRequestGuarded,
} from 'api/cerebroApiRequest'

/**
 * Fetches an organization's groups into Redux. Called by the auth bootstrap and
 * org/group-switch flows and by the Settings group-CRUD screens (replacing the
 * former `fetchOrganizationGroupsRequest` saga watcher).
 *
 * `shouldCommit` lets the org/group-switch flow drop this write when a later
 * switch has superseded it; standalone callers omit it and always commit.
 */
export async function fetchOrganizationGroups(
    organizationId: string,
    shouldCommit?: () => boolean
): Promise<void> {
    await (shouldCommit
        ? cerebroApiRequestGuarded(
              shouldCommit,
              fetchOrganizationGroupsSuccess,
              getOrganizationGroups,
              organizationId
          )
        : cerebroApiRequest(
              fetchOrganizationGroupsSuccess,
              getOrganizationGroups,
              organizationId
          ))
}
